import React, { Fragment, useContext, createRef } from "react";
import SecondaryButton from "components/Buttons/SecondaryButton";
import { modal } from "components/HeadlessModal";
import ImageEditor from "./ImageEditor";
import { ContentContext } from "context/Content";
import { apiPut, messageFromException } from "helpers/Request";
import { useAuth } from "hooks/Auth";
import { toast } from "react-hot-toast";
import PrimaryButton from "components/Buttons/PrimaryButton";

export default function EditPreviewField(props) {
    const editorRef = createRef();
    const auth = useAuth();
    const { state } = useContext(ContentContext);

    const openOverlay = () => {
        modal.wide({
            title: "Edit Preview",
            children: (
                <ImageEditor content={state.content} editorRef={editorRef} />
            ),
            buttons: () => (
                <Fragment>
                    <PrimaryButton onClick={onSave}>Save changes</PrimaryButton>
                    <SecondaryButton onClick={modal.dismiss}>
                        Cancel
                    </SecondaryButton>
                </Fragment>
            ),
        });
    };

    const onSave = () => {
        modal.update({
            disabled: true,
        });
        const id = toast.loading("Saving...");

        apiPut(`/v4/attachment/${state.content.uuid}`, auth.publication, {
            file: editorRef.current.getInstance().toDataURL().split(",")[1],
            name: `${state.content.attachment.base_name}.${state.content.attachment.preview_extension}`,
        })
            .then(() => {
                toast.success("Preview updated successfully", { id });
                modal.dismiss();
                if (props.onPreviewSave) {
                    props.onPreviewSave();
                }
            })
            .catch((err) => {
                modal.dismiss();
                toast.dismiss(id);
                modal.error({
                    title: "Unable to save preview",
                    children: messageFromException(err),
                });
            });
    };

    return (
        <SecondaryButton
            label="Edit Preview"
            className="hidden w-full sm:block"
            onClick={openOverlay}
        />
    );
}
